<script>
  import { onMount } from "svelte";
  import letters from "./sanskrit.json";
  import Board from "./components/Board.svelte";
  import SideBar from "./components/SideBar.svelte";
  import Settings from "./components/Settings.svelte";

  let isSideBarVisible = false;
  let isRecitating = false;
  let currentIndex = -1;
  let previousIndex = -1;
  let alphabet = "dvngr";
  let timeout = null;
  let player = null;

  onMount(() => {
    player = document.getElementById("sanskritAudio");
  });

  function getDuration(id) {
    return (letters[id].end - letters[id].start) * 1000;
  }

  function select(id) {
    currentIndex = id;
    play();
  }

  function recitate() {
    isRecitating = !isRecitating;
    if (isRecitating) play();
  }

  function play() {
    if (currentIndex === -1)
      if (previousIndex === -1) currentIndex = 0;
      else currentIndex = previousIndex + 1;
    player.currentTime = letters[currentIndex].start;
    player.play();
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      player.pause();
      previousIndex = currentIndex;
      if (isRecitating) {
        currentIndex = (currentIndex + 1) % 49;
        play();
      } else {
        currentIndex = -1;
      }
    }, getDuration(currentIndex));
  }

  function toggleSideBar() {
    isSideBarVisible = !isSideBarVisible;
  }

  function onChangeAlphabet(e) {
    alphabet = e.target.value;
    setTimeout(() => {
      toggleSideBar();
    }, 400);
  }
</script>

<div>
  <audio id="sanskritAudio" preload="auto">
    <source src="/sanskrit.mp3" type="audio/mpeg" />
    Your browser does not support the audio element.
  </audio>
  <Board
    {letters}
    {currentIndex}
    {isRecitating}
    {select}
    {recitate}
    {alphabet} />
  <SideBar {isSideBarVisible} {onChangeAlphabet} />
  <Settings {isSideBarVisible} on:click={toggleSideBar} />
</div>
